(self['webpackChunkheyholy_ss_theme'] =
  self['webpackChunkheyholy_ss_theme'] || []).push([
  ['/assets/quiz-products-final'],
  {
    /***/ './src/assets/js/quiz-components-v2/quiz-products-final.js'() /*!*****************************************************************!*\
  !*** ./src/assets/js/quiz-components-v2/quiz-products-final.js ***!
  \*****************************************************************/
    {
      function _createForOfIteratorHelper(r, e) {
        var t =
          ('undefined' != typeof Symbol && r[Symbol.iterator]) ||
          r['@@iterator'];
        if (!t) {
          if (
            Array.isArray(r) ||
            (t = _unsupportedIterableToArray(r)) ||
            (e && r && 'number' == typeof r.length)
          ) {
            t && (r = t);
            var _n = 0,
              F = function F() {};
            return {
              s: F,
              n: function n() {
                return _n >= r.length
                  ? { done: !0 }
                  : { done: !1, value: r[_n++] };
              },
              e: function e(r) {
                throw r;
              },
              f: F,
            };
          }
          throw new TypeError(
            'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
          );
        }
        var o,
          a = !0,
          u = !1;
        return {
          s: function s() {
            t = t.call(r);
          },
          n: function n() {
            var r = t.next();
            return (a = r.done), r;
          },
          e: function e(r) {
            (u = !0), (o = r);
          },
          f: function f() {
            try {
              a || null == t['return'] || t['return']();
            } finally {
              if (u) throw o;
            }
          },
        };
      }
      function _slicedToArray(r, e) {
        return (
          _arrayWithHoles(r) ||
          _iterableToArrayLimit(r, e) ||
          _unsupportedIterableToArray(r, e) ||
          _nonIterableRest()
        );
      }
      function _nonIterableRest() {
        throw new TypeError(
          'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.',
        );
      }
      function _unsupportedIterableToArray(r, a) {
        if (r) {
          if ('string' == typeof r) return _arrayLikeToArray(r, a);
          var t = {}.toString.call(r).slice(8, -1);
          return (
            'Object' === t && r.constructor && (t = r.constructor.name),
            'Map' === t || 'Set' === t
              ? Array.from(r)
              : 'Arguments' === t ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
              ? _arrayLikeToArray(r, a)
              : void 0
          );
        }
      }
      function _arrayLikeToArray(r, a) {
        (null == a || a > r.length) && (a = r.length);
        for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
        return n;
      }
      function _iterableToArrayLimit(r, l) {
        var t =
          null == r
            ? null
            : ('undefined' != typeof Symbol && r[Symbol.iterator]) ||
              r['@@iterator'];
        if (null != t) {
          var e,
            n,
            i,
            u,
            a = [],
            f = !0,
            o = !1;
          try {
            if (((i = (t = t.call(r)).next), 0 === l)) {
              if (Object(t) !== t) return;
              f = !1;
            } else
              for (
                ;
                !(f = (e = i.call(t)).done) &&
                (a.push(e.value), a.length !== l);
                f = !0
              );
          } catch (r) {
            (o = !0), (n = r);
          } finally {
            try {
              if (
                !f &&
                null != t['return'] &&
                ((u = t['return']()), Object(u) !== u)
              )
                return;
            } finally {
              if (o) throw n;
            }
          }
          return a;
        }
      }
      function _arrayWithHoles(r) {
        if (Array.isArray(r)) return r;
      }
      // quiz-products-final.js
      window.PACKED_PRODUCTS = {
        groups: {
          shepherds: {
            name: 'Shine-Bright Shepherds',
            dry: {
              handle: 'shine-bright-shepherds',
              sku: '10001',
              variants: {
                normal: {
                  sku: '10001',
                  grams: 7000,
                  priority: 5,
                },
                doppelt: {
                  sku: '10001-DOPPELT',
                  grams: 14000,
                  priority: 10,
                },
              },
              calories: 391.0,
              caloriesPerMJ: 1.637,
            },
            wet: {
              handle: 'shine-bright-shepherds-wet-food',
              variants: {
                small: {
                  sku: '20002',
                  grams: 2400,
                  priority: 5,
                },
                // 6 × 400g
                large: {
                  sku: '20003',
                  grams: 7200,
                  priority: 10,
                }, // 18 × 400g
              },
              caloriesPerMJ: 0.381,
            },
            snacks: {
              handle: 'shine-bright-shepherds-snacks',
              variants: {
                small: {
                  sku: '30001',
                  grams: 200,
                  priority: 5,
                },
                large: {
                  sku: '30002',
                  grams: 1200,
                  priority: 10,
                },
              },
              calories: 344.3,
              caloriesPerMJ: 2.7544,
              gramsPerPiece: 0.8,
            },
          },
          retrievers: {
            name: 'Ravishing Retrievers',
            dry: {
              handle: 'ravishing-retrievers',
              sku: '10002',
              variants: {
                normal: {
                  sku: '10002',
                  grams: 7000,
                  priority: 5,
                },
                doppelt: {
                  sku: '10002-DOPPELT',
                  grams: 14000,
                  priority: 10,
                },
              },
              calories: 379.0,
              caloriesPerMJ: 1.605,
            },
            wet: {
              handle: 'ravishing-retrievers-nassfutter',
              variants: {
                small: {
                  sku: '20005',
                  grams: 2400,
                  priority: 5,
                },
                // 6 × 400g
                large: {
                  sku: '20006',
                  grams: 7200,
                  priority: 10,
                }, // 18 × 400g
              },
              caloriesPerMJ: 0.437,
            },
            snacks: {
              handle: 'ravishing-retrievers-snacks',
              variants: {
                small: {
                  sku: '30003',
                  grams: 200,
                  priority: 5,
                },
                large: {
                  sku: '30004',
                  grams: 1200,
                  priority: 10,
                },
              },
              calories: 370.3,
              caloriesPerMJ: 2.9624,
              gramsPerPiece: 0.8,
            },
          },
          bulldogs: {
            name: 'Beautiful Bulldogs',
            dry: {
              handle: 'beautiful-bulldogs',
              sku: '10003',
              variants: {
                normal: {
                  sku: '10003',
                  grams: 7000,
                  priority: 5,
                },
                doppelt: {
                  sku: '10003-DOPPELT',
                  grams: 14000,
                  priority: 10,
                },
              },
              calories: 371.0,
              caloriesPerMJ: 1.553,
            },
            wet: {
              handle: 'beautiful-bulldogs-nassfutter',
              variants: {
                xsmall: {
                  sku: '20014',
                  grams: 2250,
                  priority: 3,
                },
                // 3 × 750g
                small: {
                  sku: '20008',
                  grams: 4500,
                  priority: 5,
                },
                // 6 × 750g
                medium: {
                  sku: '20015',
                  grams: 6750,
                  priority: 7,
                },
                // 9 × 750g
                large: {
                  sku: '20009',
                  grams: 13500,
                  priority: 10,
                }, // 18 × 750g
              },
              caloriesPerMJ: 0.534,
            },
            snacks: {
              handle: 'beautiful-bulldogs-snacks',
              variants: {
                small: {
                  sku: '30005',
                  grams: 150,
                  priority: 5,
                },
                large: {
                  sku: '30006',
                  grams: 600,
                  priority: 10,
                },
              },
              calories: 349.0,
              caloriesPerMJ: 1.461,
              gramsPerPiece: 2.0,
            },
          },
          minis: {
            name: 'Marvelous Minis',
            dry: {
              handle: 'marvelous-minis-softfutter-forelle',
              sku: '40024',
              variants: {
                soft: {
                  sku: '40024',
                  grams: 2500,
                  priority: 3,
                }, // Softfutter
              },
              calories: 391.0,
              caloriesPerMJ: 1.637,
              softCalories: 353.98,
              softCaloriesPerMJ: 1.482,
            },
            wet: {
              handle: 'marvelous-minis-wet-food',
              variants: {
                small: {
                  sku: '20029',
                  grams: 1140,
                  priority: 5,
                },
                // 6 × 190g
                large: {
                  sku: '20030',
                  grams: 3420,
                  priority: 10,
                }, // 18 × 190g
              },
              caloriesPerMJ: 0.479,
            },
            snacks: {
              handle: 'marvelous-minis-snacks',
              variants: {
                small: {
                  sku: '30007',
                  grams: 200,
                  priority: 5,
                },
                large: {
                  sku: '30008',
                  grams: 1200,
                  priority: 10,
                },
              },
              calories: 408.8,
              caloriesPerMJ: 3.2704,
              gramsPerPiece: 0.8,
            },
          },
          herders: {
            name: 'Happy Herders',
            dry: {
              handle: 'happy-herders',
              sku: '10005',
              variants: {
                normal: {
                  sku: '10005',
                  grams: 7000,
                  priority: 5,
                },
                doppelt: {
                  sku: '10005-DOPPELT',
                  grams: 14000,
                  priority: 10,
                },
              },
              calories: 379.0,
              caloriesPerMJ: 1.587,
            },
            wet: {
              handle: 'happy-herders-wet-food',
              variants: {
                small: {
                  sku: '20020',
                  grams: 2400,
                  priority: 5,
                },
                // 6 × 400g
                large: {
                  sku: '20021',
                  grams: 7200,
                  priority: 10,
                }, // 18 × 400g
              },
              caloriesPerMJ: 0.434,
            },
            snacks: {
              handle: 'happy-herders-snacks',
              variants: {
                small: {
                  sku: '30009',
                  grams: 200,
                  priority: 5,
                },
                large: {
                  sku: '30010',
                  grams: 1200,
                  priority: 10,
                },
              },
              calories: 363.8,
              caloriesPerMJ: 2.9104,
              gramsPerPiece: 0.8,
            },
          },
          hunters: {
            name: 'Hearty Hunters',
            dry: {
              handle: 'hearty-hunters',
              sku: '10006',
              variants: {
                normal: {
                  sku: '10006',
                  grams: 7000,
                  priority: 5,
                },
                doppelt: {
                  sku: '10006-DOPPELT',
                  grams: 14000,
                  priority: 10,
                },
              },
              calories: 371.0,
              caloriesPerMJ: 1.553,
            },
            wet: {
              handle: 'hearty-hunters-wet-food',
              variants: {
                small: {
                  sku: '20023',
                  grams: 1200,
                  priority: 5,
                },
                // 6 × 200g
                large: {
                  sku: '20024',
                  grams: 3600,
                  priority: 10,
                }, // 18 × 200g
              },
              caloriesPerMJ: 0.523,
            },
            snacks: {
              handle: 'hearty-hunters-snacks-1',
              variants: {
                small: {
                  sku: '30011',
                  grams: 200,
                  priority: 5,
                },
                large: {
                  sku: '30012',
                  grams: 1200,
                  priority: 10,
                },
              },
              calories: 383.1,
              caloriesPerMJ: 3.0648,
              gramsPerPiece: 0.8,
            },
          },
          bigbuddies: {
            name: 'Big Buddies',
            dry: {
              handle: 'big-buddies',
              sku: '10007',
              variants: {
                normal: {
                  sku: '10007',
                  grams: 7000,
                  priority: 5,
                },
                doppelt: {
                  sku: '10007-DOPPELT',
                  grams: 14000,
                  priority: 10,
                },
              },
              calories: 378.1,
              caloriesPerMJ: 1.583,
            },
            wet: {
              handle: 'big-buddies-wet-food',
              variants: {
                small: {
                  sku: '20017',
                  grams: 4800,
                  priority: 5,
                },
                // 6 × 800g
                large: {
                  sku: '20018',
                  grams: 14400,
                  priority: 10,
                }, // 18 × 800g
              },
              caloriesPerMJ: 0.529,
            },
            snacks: {
              handle: 'big-buddies-snacks',
              variants: {
                small: {
                  sku: '30013',
                  grams: 200,
                  priority: 5,
                },
                large: {
                  sku: '30014',
                  grams: 1200,
                  priority: 10,
                },
              },
              calories: 383.1,
              caloriesPerMJ: 3.0648,
              gramsPerPiece: 0.8,
            },
          },
          heroichunters: {
            name: 'Heroic Hunters',
            dry: {
              handle: 'heroic-hunters',
              sku: '10008',
              variants: {
                normal: {
                  sku: '10008',
                  grams: 7000,
                  priority: 5,
                },
                doppelt: {
                  sku: '10008-DOPPELT',
                  grams: 14000,
                  priority: 10,
                },
              },
              calories: 391.71,
              caloriesPerMJ: 1.64,
            },
            wet: {
              handle: 'heroic-hunters-wet-food',
              variants: {
                small: {
                  sku: '20026',
                  grams: 2400,
                  priority: 5,
                },
                // 6 × 400g
                large: {
                  sku: '20027',
                  grams: 7200,
                  priority: 10,
                }, // 18 × 400g
              },
              caloriesPerMJ: 0.373,
            },
            snacks: {
              handle: 'heroic-hunters-snacks',
              variants: {
                small: {
                  sku: '30015',
                  grams: 200,
                  priority: 5,
                },
                large: {
                  sku: '30016',
                  grams: 1200,
                  priority: 10,
                },
              },
              calories: 344.3,
              caloriesPerMJ: 2.7544,
              gramsPerPiece: 0.8,
            },
          },
        },
        // Main function - returns group key
        resolveGroup: function resolveGroup() {
          var _JSON$parse$dropdownS;
          var raw = localStorage.getItem('quiz')
            ? (_JSON$parse$dropdownS = JSON.parse(
                localStorage.getItem('quiz'),
              ).dropdownStates) === null || _JSON$parse$dropdownS === void 0
              ? void 0
              : _JSON$parse$dropdownS['entry.62437307']
            : null;
          if (!raw) return 'hunters';
          var data = this.parseEntry(raw);
          if (data.type === 'not_sure') {
            return 'hunters';
          }
          if (data.type === 'purebred') {
            return this.findGroupByBreedName(data.value);
          }
          if (data.type === 'mixed') {
            if (data.value_2) {
              var groupFromV2 = this.findGroupByBreedName(data.value_2);
              if (groupFromV2 && groupFromV2 !== 'hunters') return groupFromV2;
            }
            if (data.value_1) {
              var groupFromV1 = this.findGroupByBreedName(data.value_1);
              if (groupFromV1 && groupFromV1 !== 'hunters') return groupFromV1;
            }
          }
          return 'hunters';
        },
        parseEntry: function parseEntry(str) {
          if (!str)
            return {
              type: 'not_sure',
            };
          if (str === 'not_sure') {
            return {
              type: 'not_sure',
            };
          }
          if (str.includes('breedTypeStates: purebred')) {
            var match = str.match(/value: (.+)$/);
            return {
              type: 'purebred',
              value: match ? match[1].trim() : '',
            };
          }
          if (str.includes('breedTypeStates: mixed')) {
            var parts = str.split(';').reduce(function (acc, part) {
              var _part$trim$split = part.trim().split(': '),
                _part$trim$split2 = _slicedToArray(_part$trim$split, 2),
                key = _part$trim$split2[0],
                val = _part$trim$split2[1];
              if (key && val) acc[key.trim()] = val.trim();
              return acc;
            }, {});
            return {
              type: 'mixed',
              value_1: parts['value_1'] || '',
              value_2: parts['value_2'] || '',
            };
          }
          return {
            type: 'unknown',
            raw: str,
          };
        },
        findGroupByBreedName: function findGroupByBreedName(breedName) {
          if (!breedName) return null;
          var lower = breedName.toLowerCase();
          var list = window.breedSearchDatabreed_1 || [];
          var _iterator = _createForOfIteratorHelper(list),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done; ) {
              var entry = _step.value;
              if (
                entry.breedList.some(function (b) {
                  return b.toLowerCase() === lower;
                })
              ) {
                var url = (entry.breedUrl || '').toLowerCase();
                if (url.includes('bulldogs')) return 'bulldogs';
                if (url.includes('ravishing-retrievers')) return 'retrievers';
                if (url.includes('shine-bright-shepherds')) return 'shepherds';
                if (
                  url.includes('collections/minis') ||
                  url.includes('marvelous-minis')
                )
                  return 'minis';
                if (url.includes('happy-herders')) return 'herders';
                if (url.includes('hearty-hunters')) return 'hunters';
                if (url.includes('big-buddies')) return 'bigbuddies';
                if (url.includes('heroic-hunters')) return 'heroichunters';
              }
            }

            // Fallback search by keywords
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          if (
            lower.includes('bulldog') ||
            lower.includes('frenchie') ||
            lower.includes('mops') ||
            lower.includes('boston')
          )
            return 'bulldogs';
          if (
            lower.includes('retriever') ||
            lower.includes('labrador') ||
            lower.includes('golden')
          )
            return 'retrievers';
          if (
            lower.includes('schäfer') ||
            lower.includes('shepherd') ||
            lower.includes('malinois')
          )
            return 'shepherds';
          if (
            lower.includes('chihuahua') ||
            lower.includes('york') ||
            lower.includes('malteser') ||
            lower.includes('havaneser') ||
            lower.includes('jack russell')
          )
            return 'minis';
          if (
            lower.includes('collie') ||
            lower.includes('australian shepherd') ||
            lower.includes('border')
          )
            return 'herders';
          if (
            lower.includes('mastiff') ||
            lower.includes('cane corso') ||
            lower.includes('rottweiler') ||
            lower.includes('dogge')
          )
            return 'bigbuddies';
          if (
            lower.includes('weimaraner') ||
            lower.includes('vizsla') ||
            lower.includes('pointer') ||
            lower.includes('setter')
          )
            return 'heroichunters';
          return 'hunters';
        },
      };

      /***/
    },
  },
  /******/ (__webpack_require__) => {
    // webpackRuntimeModules
    /******/ var __webpack_exec__ = (moduleId) =>
      __webpack_require__((__webpack_require__.s = moduleId));
    /******/ var __webpack_exports__ = __webpack_exec__(
      './src/assets/js/quiz-components-v2/quiz-products-final.js',
    );
    /******/
  },
]);
